import React, { useMemo, useState } from "react";
import { StyleSheet, View } from "react-native";

import MapInputModal from "./Components/Modals/MapInputModal";

import { formatLocationAddress } from "@/formatting/location";
import { type AppUserSession } from "@/schemas/auth/session";
import { type UserCoordinate } from "@/schemas/location/cordinate";
import { type UserLocation } from "@/schemas/location/user_location";
import { UserAttributeType } from "@/schemas/profile/UserAttributeSet";
import ProfileService from "@/services/user/profile";
import AttributeCard from "@/Components/PersonalAttributes/Components/AttributeCard";
import {
  AttributeCardDisplayVariantType,
  AttributeCardType,
} from "@/Components/PersonalAttributes/types";

type ResidenceProps = {
  session: AppUserSession;
  residence: UserLocation | null;
};

function getInitialCoords(residence: UserLocation | null): UserCoordinate {
  if (residence !== null) {
    return residence.coordinates;
  } else {
    const sf_coords = {
      latitude: 37.7807513,
      longitude: -122.4154,
    };
    return sf_coords;
  }
}

function Residence({ session, residence }: ResidenceProps): React.JSX.Element {
  const [showModal, setShowModal] = useState(false);
  const [userResidence, setUserResidence] = useState<UserLocation | null>(
    residence,
  );

  const formattedAddress = useMemo(() => {
    return formatLocationAddress(residence);
  }, [residence]);

  const residenceAttribute = {
    id: UserAttributeType.RESIDENCE,
    label: formattedAddress,
    iconLabel: "",
  };

  const handleSave = async (cords: UserCoordinate): Promise<void> => {
    const profileService = new ProfileService(session);

    profileService.updateAttributes(UserAttributeType.RESIDENCE, [
      cords.longitude.toString(),
      cords.latitude.toString(),
    ]);

    setUserResidence(null);
  };

  return (
    <View style={styles.container}>
      <AttributeCard
        attributeType={AttributeCardType.LOCATION}
        attributeId={UserAttributeType.RESIDENCE}
        values={[residenceAttribute]}
        onPress={() => setShowModal(true)}
        icon="🏠"
        isDisabled={true}
        variant={AttributeCardDisplayVariantType.ACCOUNT}
      />
      <MapInputModal
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        handleSave={handleSave}
        initialCords={getInitialCoords(userResidence)}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "48%",
    marginBottom: 12,
  },
});

export default Residence;
